import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import './User.css';

export default function Profile() {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    if (window.confirm('Are you sure you want to logout?')) {
      logout();
      navigate('/login');
    }
  };

  const menuItems = [
    {
      icon: '👤',
      title: 'Edit Profile',
      subtitle: 'Update your personal information',
      onClick: () => navigate('/user/edit-profile')
    },
    {
      icon: '💳',
      title: 'Payment Methods',
      subtitle: 'Cash on Delivery (COD)',
      onClick: () => alert('Payment Methods: Cash on Delivery is available for now.')
    },
    {
      icon: '📦',
      title: 'Order History',
      subtitle: 'View all your orders',
      onClick: () => navigate('/user/orders')
    },
    {
      icon: '❓',
      title: 'Help & Support',
      subtitle: 'Get help with your orders',
      onClick: () => alert('Help & Support\n\nContact us at:\nsupport@freshdelivery.com\nPhone: 0300-1234567')
    },
    {
      icon: 'ℹ️',
      title: 'About Us',
      subtitle: 'Learn more about Fresh Delivery',
      onClick: () => alert('Fresh Delivery - Farm to Your Door\n\nVersion 1.0.0\n\nWe deliver fresh fruits and vegetables directly from farms to your doorstep.')
    }
  ];

  return (
    <div className="user-profile">
      <div className="container">
        {/* Profile Header */}
        <div className="profile-header">
          <div className="profile-avatar">
            {user?.name?.charAt(0)?.toUpperCase() || 'U'}
          </div>
          <h2 className="profile-name">{user?.name || 'User'}</h2>
          <p className="profile-email">{user?.email || '—'}</p>
          <div className="profile-role-badge">
            🌟 {user?.role?.toUpperCase() || 'USER'}
          </div>
        </div>

        {/* Menu Items */}
        <div className="profile-menu">
          {menuItems.map((item, index) => (
            <button
              key={index}
              className="profile-menu-item"
              onClick={item.onClick}
            >
              <div className="menu-item-icon">{item.icon}</div>
              <div className="menu-item-content">
                <div className="menu-item-title">{item.title}</div>
                <div className="menu-item-subtitle">{item.subtitle}</div>
              </div>
              <div className="menu-item-arrow">›</div>
            </button>
          ))}
        </div>

        {/* Logout Button */}
        <button
          className="btn btn-danger btn-block logout-button"
          onClick={handleLogout}
        >
          🚪 Logout
        </button>

        {/* App Info */}
        <div className="app-info">
          <h3 className="app-name">Fresh Delivery</h3>
          <p className="app-version">Version 1.0.0</p>
          <p className="app-copyright">© 2026 Fresh Delivery. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
}